module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-left-top-ties.34149f3e.png";